import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';
import {IPConfig} from '../types/ipRestrictionApi.type';

const ipSettingsEndpoint = (path: string) =>
  `${BASE_URL}/projectmanagement/api/v1/project/ip-settings${path}`;

export const getIpRestrictionDetails = async (): Promise<IPConfig> => {
  const {data} = await apiClient.get<IPConfig>(ipSettingsEndpoint('/view'));
  return data;
};

export const postIPRestrictions = async (payload: IPConfig) => {
  const {data} = await apiClient.post<any>(ipSettingsEndpoint(''), payload);
  return data;
};
